const ALLOWED_PROTOCOLS = new Set(['http:', 'https:']);

export default function buildSafeFresUrl(
  fresUrl?: string | null,
  quoteId?: string
): string {
  const trimmed = typeof fresUrl === 'string' ? fresUrl.trim() : '';
  if (!trimmed) {
    return '';
  }

  let parsed: URL;
  try {
    parsed = new URL(trimmed);
  } catch {
    return '';
  }

  if (!ALLOWED_PROTOCOLS.has(parsed.protocol)) {
    return '';
  }

  const baseUrl = trimmed.endsWith('/') ? trimmed.slice(0, -1) : trimmed;
  if (!quoteId) {
    return baseUrl;
  }

  return `${baseUrl}/quote-builder/?quoteIds=${encodeURIComponent(quoteId)}`;
}
